import {
  GridActionsCellItem,
  GridColumns,
  GridRenderCellParams,
  GridRowParams
} from '@mui/x-data-grid'
import { Row } from 'react-data-grid'
import { AiOutlineEye } from 'react-icons/ai'
import { FiCopy, FiTrash } from 'react-icons/fi'
import { HiOutlinePencil } from 'react-icons/hi'
import { maskDate } from 'util/masks'
import { EtapaGrid } from '../style'
import { PipelineTabPipeline } from 'store/modules/backoffice/configuracaoKanban/types'
import { Switch, Tooltip } from '@mui/material'
import PrivateComponent from 'components/PrivateComponent'

const headerTheme = 'table-header--purple'

interface GetPipelineColumnsProps {
  onView: (row: PipelineTabPipeline) => void
  onEdit: (row: PipelineTabPipeline) => void
  onToggleStatus: (row: PipelineTabPipeline) => void
  onDuplicate: (row: PipelineTabPipeline) => void
  onDelete: (row: PipelineTabPipeline) => void
}

export const getPipelineColumns = ({
  onView,
  onEdit,
  onToggleStatus,
  onDuplicate,
  onDelete
}: GetPipelineColumnsProps): GridColumns<Row> => [
  {
    field: 'nome',
    headerName: 'Pipeline',
    headerClassName: headerTheme,
    align: 'left',
    headerAlign: 'left',
    flex: 1
  },
  {
    field: 'descricao',
    headerName: 'Descrição',
    headerClassName: headerTheme,
    align: 'left',
    headerAlign: 'left',
    flex: 1
  },
  {
    field: 'ativo',
    headerName: 'Ativo',
    headerClassName: headerTheme,
    align: 'left',
    headerAlign: 'left',
    flex: 1,
    renderCell: (params: GridRenderCellParams) => (
      <span className="table-cell-trucate">
        {params?.value ? 'Ativo' : 'Inativo'}
      </span>
    )
  },
  {
    field: 'etapas',
    headerName: 'Etapas',
    headerClassName: headerTheme,
    align: 'left',
    headerAlign: 'left',
    flex: 1,
    renderCell: (params: GridRenderCellParams) => (
      <div className="d-flex gap-2 flex-column p-2">
        {params?.value.length > 0 && (
          <label>{params?.value.length} etapas</label>
        )}
        <span className="d-flex flex-wrap gap-2">
          {Array.isArray(params?.value)
            ? params?.value.map((x, i) => (
                <EtapaGrid key={i}>{x.nome}</EtapaGrid>
              ))
            : params?.value}
        </span>
      </div>
    )
  },
  {
    field: 'site',
    headerName: 'Site',
    headerClassName: headerTheme,
    align: 'left',
    headerAlign: 'left',
    flex: 1,
    renderCell: (params: GridRenderCellParams) => (
      <span className="table-cell-trucate">
        {params?.value ? 'Sim' : 'Não'}
      </span>
    )
  },
  {
    field: 'dataCriacao',
    headerName: 'Data de Criação',
    headerClassName: headerTheme,
    align: 'left',
    headerAlign: 'left',
    flex: 1,
    renderCell: (params: GridRenderCellParams) => (
      <span className="table-cell-trucate">
        {params?.value ? maskDate(params?.value, 'DD/MM/YYYY') : ''}
      </span>
    )
  },
  {
    field: 'actions',
    headerName: 'Ações',
    headerClassName: headerTheme,
    type: 'actions',
    align: 'center',
    minWidth: 200,
    getActions: (params: GridRowParams) => {
      const actions = [
        <Tooltip title="Visualizar" key={`view-${params.row.id}`}>
          <GridActionsCellItem
            key={`view-${params.row.id}`}
            icon={<AiOutlineEye size={15} />}
            onClick={() => onView(params.row)}
            size="medium"
            label="Visualizar"
          />
        </Tooltip>
      ]

      if (params.row.ativo) {
        actions.splice(
          1,
          0,
          <PrivateComponent
            key={`copy-${params.row.id}`}
            screen="configuracaoKanban"
            typeActions="gravar"
          >
            <Tooltip title="Duplicar" key={`copy-${params.row.id}`}>
              <GridActionsCellItem
                icon={<FiCopy size={15} />}
                onClick={() => onDuplicate(params.row)}
                size="medium"
                label="Duplicar"
              />
            </Tooltip>
          </PrivateComponent>,
          <PrivateComponent
            key={`edit-${params.row.id}`}
            screen="configuracaoKanban"
            typeActions="gravar"
          >
            <Tooltip title="Editar" key={`edit-${params.row.id}`}>
              <GridActionsCellItem
                icon={<HiOutlinePencil size={15} />}
                onClick={() => onEdit(params.row)}
                label="Editar"
              />
            </Tooltip>
          </PrivateComponent>
        )

        actions.push(
          <PrivateComponent
            key={`toggle-${params.row.id}`}
            screen="configuracaoKanban"
            typeActions="gravar"
          >
            <Tooltip title="Ativar/Desativar" key={`toggle-${params.row.id}`}>
              <GridActionsCellItem
                icon={<Switch size="small" checked={params.row.status} />}
                onClick={() => onToggleStatus(params.row)}
                size="medium"
                label="Ativar/Desativar"
              />
            </Tooltip>
          </PrivateComponent>
        )

        actions.push(
          <PrivateComponent
            key={`delete-${params.row.id}`}
            screen="configuracaoKanban"
            typeActions="deletar"
          >
            <Tooltip title="Deletar" key={`delete-${params.row.id}`}>
              <GridActionsCellItem
                icon={<FiTrash size={15} />}
                onClick={() => onDelete(params.row)}
                size="medium"
                label="Deletar"
              />
            </Tooltip>
          </PrivateComponent>
        )
      }

      return actions
    }
  }
]
